// ทางเข้าของ wizard "สร้าง AI Assistant ของคุณ" จาก NavBar (แผน v3 ข้อ 2–4) — แยกเป็นฟังก์ชันล้วนให้ทดสอบได้
//   first-time : เด้งเองครั้งเดียวต่อหน่วยงาน ให้ผู้ดูแลคนแรกที่เข้า แล้วนับรวมทั้งหน่วยงาน (ตาราง mas.AssistantWizardOnboarding)
//                + ปุ่ม "สร้าง AI Assistant" ในเมนูโปรไฟล์ (ไว้ทดสอบ ไม่ตรวจ/ไม่บันทึกสถานะ)
//   assistant  : เมนู "AI Assistant" ใน sidebar

// ผู้ดูแลหน่วยงาน = roleId 0 (เช่น Owner — RoleId เป็นคนละแกนกับ isSuperAdmin) / 1 (Admin) — ชุดเดียวกับที่เปิด wizard จากเมนูได้
// SuperAdmin ที่สลับเข้าหน่วยงานก็นับเป็นผู้ดูแล (backend ตอบ show=false ให้เองถ้ายังไม่ได้เข้าหน่วยงาน)
const MANAGER_ROLE_IDS = ['0', '1'];

// หน้าที่ไม่ใช่ portal ของผู้ดูแล (หน้าแชท/snippet/login) — ไม่เด้ง (ชุดเดียวกับที่ไม่ขึ้น consent dialog)
const NO_POPUP_PATHS = ['FullStream', 'Snippet', 'LoginSnippet', 'Login'];

/**
 * ถึงเวลาถาม backend ว่าจะเด้ง wizard ครั้งแรกไหม — ถามครั้งเดียวต่อการโหลดหน้า หลังรู้ผล consent และ consent dialog ปิดแล้ว
 * (ถ้าเด้งตอน consent dialog ยังเปิด จะซ้อนกันสองชั้น) · หน่วยงานไหนเคยเด้งแล้ว backend เป็นคนตัดสิน
 */
export function shouldCheckOnboarding({ roleId, isSuperAdmin = false, pathUrl, consentChecked, consentDialogOpen, alreadyChecked }) {
  if (alreadyChecked) return false;
  if (isSuperAdmin !== true && !MANAGER_ROLE_IDS.includes(String(roleId))) return false;
  if (NO_POPUP_PATHS.includes(pathUrl)) return false;
  return consentChecked === true && !consentDialogOpen;
}

/**
 * คำตอบของ AssistantWizard/OnboardingStatus — เด้งเฉพาะเมื่อสำเร็จและ show เป็น true เท่านั้น (อย่างอื่น = ไม่เด้ง)
 * wizardOpen: ผู้ใช้เปิด wizard เอง (เมนู AI Assistant) ก่อนคำตอบนี้มาถึง → ไม่เด้งทับ/ไม่สลับโหมดกลางทาง
 *   และไม่บันทึกว่าเห็นแล้ว (ยังไม่ได้เห็นแบบครั้งแรกจริง — โหลดหน้าครั้งถัดไปจะเด้งตามปกติ)
 */
export function shouldAutoOpenWizard(response, { wizardOpen = false } = {}) {
  if (wizardOpen) return false;
  return response?.status === 0 && response?.data?.show === true;
}

// เมนู sidebar ที่เปิด wizard ทับหน้าปัจจุบันแทนการเปลี่ยนหน้า (design: เมนู Dashboard ยัง active ระหว่างเปิด)
// อ้างด้วย href — ตัวระบุเมนูเดียวกับที่ใช้เช็คสิทธิ์ (SuperAdminRights / adminRights)
const SIDEBAR_WIZARD_ITEMS = { AIAssistant: 'assistant' };

/** โหมดของ wizard ที่เมนูนี้เปิด หรือ null = เมนูปกติ (เปลี่ยนหน้า) */
export function sidebarWizardMode(item) {
  return SIDEBAR_WIZARD_ITEMS[item?.href] || null;
}
